import type { Marker, MarkerClustererOptions } from "@googlemaps/markerclusterer";
import { MarkerClusterer } from "@googlemaps/markerclusterer";

import { createImageIcon } from "../../store-locator-icons";

type Theme = "dark" | "light";
type LayoutVersion = "v1" | "v2";

function createClusterMarker(count: number, position: google.maps.LatLng, theme: Theme) {
  const isDark = theme === "dark";

  const styles = {
    color: isDark ? "#000000" : "#FFFFFF",
    fill: isDark ? "#FFFFFF" : "#2D2926",
    stroke: "#FFFFFF",
  };

  const iconSVG = createImageIcon(`
     <svg width="40" height="40" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
        <circle fill="${styles.fill}" stroke="${styles.stroke}" stroke-width="1" cx="20" cy="20" r="19"></circle>
    </svg>
 `);

  return new google.maps.Marker({
    label: {
      text: String(count),
      color: styles.color,
      fontSize: "16px",
      fontWeight: "bold",
    },
    icon: {
      url: iconSVG,
    },
    position,
    zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
  });
}

export const createClusterer = ({ theme = "dark", layoutVersion }: { theme?: Theme; layoutVersion: LayoutVersion }) => {
  return function (map: google.maps.Map, markers: Marker[]) {
    const options: MarkerClustererOptions = {
      map,
      markers,
    };

    if (layoutVersion === "v2") {
      options.renderer = {
        render: ({ count, position }) => createClusterMarker(count, position, theme),
      };
    }

    return new MarkerClusterer(options);
  };
};
